// extracted by mini-css-extract-plugin
module.exports = {"heading1":"page_heading1__1G522","card":"page_card__3wvxr"};